import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const WebsiteKeywordsPage2TableWrapper = styled.div`
    border-radius: 3px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.midnight[600], 0.08)};
`;
